
import P, { shape } from 'prop-types';
import BoxDataComponent from './BoxDataComponent';

const FrameMetrics = ({data}) => 
    (
        <>
            <BoxDataComponent title="Quadro Métricas" data={data}/>
        </>
    )

FrameMetrics.propTypes = {
    data: P.arrayOf(
      shape({
        id: P.number,
        value: P.string,
      })
    ),
};

FrameMetrics.defaultProps = {
    data: null,
};

export default FrameMetrics;
